import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { SwiperWraperAffiliate, } from "./styles";
import { useWindowSize } from '../../hook/useWindowSize';
import { CardAffiliate3 } from './CardAffiliate3';
import { CardAffiliate2 } from './CardAffiliate2';
import { CardAffiliate1 } from './CardAffiliate1';

export const SlideMainCardAffiliate = ({ data }) => {
    const size = useWindowSize()
    const getSlidePreview = () => {
        let preview = 3;
        if (size.width < 850) {
            preview = 1.1
        }
        return preview;
    };

    return (
        <div className="w-[100%]">
            <SwiperWraperAffiliate
                slidesPerView={getSlidePreview()}
                spaceBetween={15}
            >
                <SwiperSlide style={{ height: "auto", minHeight: '346px' }}>
                    <CardAffiliate1 data={data} />
                </SwiperSlide>
                <SwiperSlide style={{ height: "auto" }}>
                    <CardAffiliate2 data={data} style={{ height: "100%" }} />
                </SwiperSlide>
                <SwiperSlide style={{ height: "auto" }}>
                    <CardAffiliate3 data={data} style={{ height: "100%" }} className={"!mr-[15px] md:!mr-0"} />
                </SwiperSlide>
            </SwiperWraperAffiliate>
        </div>
    )
}
